import React from "react";
import { FlatList } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import UserRankingRow from "app/scenes/CurrentTrackScreen/ProgressScreen/UserRankingRow";
import Header from "app/scenes/RankingScreen/Header";
import { requestExternalUser } from "@microdoing/shared/services/externalProfile/actions";
import { Box } from "app/components/common";
import WebDesktopView from "app/components/common/Web/WebDesktopView";
import { breadCrumbsTeamRankingScreen } from "app/navigation/breadcrumb/BreadcrumbPaths";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import { getUserId } from "@microdoing/shared/services/user/selectors";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import MainHeader from "app/components/common/MainHeader";

const TeamDetailsScreen = ({ navigation, route }) => {
  const { users, name } = route?.params?.team || { users: [] };

  const userId = useSelector(getUserId);

  const teamRankingBreadcrumb = {
    routeName: "TeamDetails",
    label: name,
  };

  const insets = useSafeAreaInsets();

  const dispatch = useDispatch();

  const handleUserPress = user => () => {
    dispatch(requestExternalUser({ userId: user?.user }));
  };

  const keyExtractor = (item, index) => {
    return index.toString();
  };

  const sortUsers = () => {
    return users?.sort((a, b) => b.totalDoneActions - a.totalDoneActions);
  };

  const renderUserList = data => {
    const { index } = data;
    const { user } = data.item;
    const isMe = user === userId;

    return (
      <>
        <UserRankingRow
          user={data.item}
          rank={data.index + 1}
          name={data.item.name}
          totalDoneActions={data.item.totalDoneActions}
          key={data.index}
          isUser={isMe}
          onPress={handleUserPress(data.item)}
        />
        {index !== users.length - 1 && (
          <Box borderTopWidth={1} borderTopColor="neutral.75" />
        )}
      </>
    );
  };

  return (
    <WebDesktopView
      breadcrumbsPath={[...breadCrumbsTeamRankingScreen, teamRankingBreadcrumb]}
    >
      <Box
        flex={1}
        borderRadius={isWebDesktop ? 8 : 0}
        backgroundColor="neutral.white"
        style={{ paddingTop: insets.top }}
      >
        {!isWebDesktop && <MainHeader title={name} />}
        <FlatList
          data={sortUsers()}
          renderItem={renderUserList}
          keyExtractor={keyExtractor}
          keyboardShouldPersistTaps="always"
        />
      </Box>
    </WebDesktopView>
  );
};

export default TeamDetailsScreen;
